import { Typography } from '@mui/material';

import { decodeEntities } from '../utils/parseFindings';

export function unwrapNarrative(text: string): string {
  const match = text.match(/^<\w+>([\s\S]*)<\/\w+>$/);
  return decodeEntities((match?.[1] ?? text).trim());
}

export function Narrative({
  text,
  color = 'text.secondary',
}: {
  text?: string;
  color?: string;
}) {
  const prose = unwrapNarrative(text ?? '');
  if (!prose) {
    return null;
  }

  return (
    <Typography variant="body1" component="p" data-testid="pe-narrative" sx={{ color }}>
      {prose}
    </Typography>
  );
}
